module.exports = __webpack_public_path__ + "img/ico-check.4f525bdf.svg";